import request from '../network';

const prefix = 'lz-member-server';

export const getClauseListApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/info/list`,
    method: 'POST',
    data,
  });
};

export const addClauseApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/info/add`,
    method: 'POST',
    data,
  });
};

export const deleteClauseApi = (id: number | string) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/info/${id}`,
    method: 'POST',
  });
};

export const getClauseDetailApi = (id: number | string) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/info/${id}`,
    method: 'GET',
  });
};

export const editClauseApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/info/edit`,
    method: 'POST',
    data,
  });
};

export const addClauseVersionApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/version/add`,
    method: 'POST',
    data,
  });
};

export const getClauseVersionListApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/version/list`,
    method: 'POST',
    data,
  });
};

export const publishClauseVersionApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/version/edit`,
    method: 'POST',
    data,
  });
};

export const getClauseVersionDetailApi = (id: number | string) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/version/${id}`,
    method: 'GET',
  });
};

export const updateClauseVersionApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/version/update`,
    method: 'POST',
    data,
  });
};

export const deleteClauseVersionApi = (id: number | string) => {
  return request({
    url: `${prefix}/royalcanin/admin/clause/version/${id}`,
    method: 'POST',
  });
};
